import spoof, { getPreloadMetas as spoofMetas } from './spoof';
import formular, { getPreloadMetas as formularMetas } from './formular';
export { default as injectFonts } from './injectFonts';
export var fonts = {
  spoof: spoof,
  formular: formular
};
export var fontMetas = {
  spoof: spoofMetas,
  formular: formularMetas
};